import React from "react";

import { Element } from "@craftjs/core";
import { Box } from "components/ui";

export const AccordionPanelTitle = ({ ...props }) => {
	return <Box>{props.children}</Box>;
};
export const AccordionPanelContent = ({ ...props }) => {
	return <div>{props.children}</div>;
};

export const PageAccordionPanel = ({ ...props }) => {
	return (
		<Box {...props}>
			<Element id="accordion-title" is={AccordionPanelTitle}></Element>
			<Element id="accordion-content" is={AccordionPanelContent}></Element>
		</Box>
	);
};
